import constants from '../utils/constants.js';
import SessionStore from '../stores/SessionStore.js'
import useStores from './useStores.js';

import Header from './Header.js';

const {GAME_LENGTH} = constants;

function PageNote() {
  useStores([SessionStore]);

  const practice = SessionStore.getPractice();

  return (
    <>
      <Header />

      <div className="middle">
        <p>
          Estás a punto de comenzar una serie de tarjetas didácticas con el objetivo de identificar la nota (de La a Sol) que se muestra en cada una de ellas.
        </p>
        <p>
          Recibirás {GAME_LENGTH} tarjetas que deberás responder. Tu puntuación es el tiempo que tardas en responderlas todas correctamente, con una penalización de un segundo adicional por cada respuesta incorrecta. Cuanto menor sea tu puntuación, mejor lo habrás hecho.
        </p>
        <p>
          <b>Tipo de práctica:</b><br/>
          <label
            onClick={() => SessionStore.setPractice('name')}
          >
            <input
              type="radio"
              name="practice"
              value="name"
              checked={practice === 'name'}
            /> Nombres de las notas
          </label><br/>
          <label
            onClick={() => SessionStore.setPractice('position')}
          >
            <input
              type="radio"
              name="practice"
              value="position"
              checked={practice === 'position'}
            /> Posiciones de los dedos</label>
        </p>
      </div>

      <div className="bottom">
        <div class="buttons">
          <button
            onClick={() => {
              SessionStore.startGame();
            }}
          >
            Iniciar el juego
          </button>
        </div>
      </div>
    </>
  );
}

export default PageNote;
